export default "__VITE_ASSET__Crf_pne0__"